@if (visible) {
  <div class="form-update-loading-overlay" aria-live="polite" aria-busy="true">
    <p-progressSpinner
      styleClass="form-update-loading-spinner"
      strokeWidth="4"
      ariaLabel="Loading form data" />
  </div>
}
